<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 135.0" :width="width" :fill="color">
    <path
        d="m8.8281 54.961c0.83984 21.469 18.328 38.828 39.82 39.52 11.281 0.35156 21.93-3.75 30.012-11.578 8.0898-7.8281 12.539-18.34 12.539-29.602 0-7.1797-1.8906-14.199-5.3984-20.371-0.058593 0.070312-0.12109 0.14062-0.19141 0.21094l-0.60156 0.60156c-0.76172 0.76172-1.6211 1.3906-2.5391 1.8711 2.9297 5.3906 4.5 11.461 4.5 17.691 0 20.191-16.422 36.781-36.602 36.988h-0.37109c-19.719 0-36.27-15.922-36.969-35.648-0.42969-12.27 5.2109-23.922 15.102-31.172 0.48047-0.35156 0.78125-0.85938 0.85938-1.4297 0.078125-0.55859-0.070312-1.1211-0.41016-1.5586-0.41016-0.53125-1.0391-0.82031-1.6797-0.82031-0.42969 0-0.85938 0.12891-1.2305 0.39844-11.09 8.1094-17.391 21.16-16.852 34.91z"/>
    <path
        d="m84.309 33.031 0.60156-0.60156c3.6992-3.6992 3.6992-9.7305 0-13.441l-7.3203-7.3203-14.039 14.039 7.3203 7.3203c3.6992 3.6992 9.7305 3.7109 13.441 0z"/>
    <path
        d="m60.988 14.5c-0.58984 0-1.1797 0.23047-1.6289 0.67969-0.44922 0.44922-0.67969 1.0195-0.67969 1.6289s0.23828 1.1992 0.67969 1.6406l5.0312 5.0312 3.2695-3.2695-5.0312-5.0312c-0.44922-0.44922-1.0391-0.67969-1.6289-0.67969z"/>
    <path
        d="m67.059 10.738 5.0312 5.0312 3.2695-3.2695-5.0312-5.0312c-0.89844-0.89844-2.3711-0.89844-3.2695 0-0.89844 0.89844-0.89844 2.3711 0 3.2695z"/>
    <path
        d="m47.141 58.078c0.16016 0 0.30078 0.070313 0.39844 0.19922 0.10156 0.12891 0.12891 0.28125 0.089844 0.42969l-3.8789 14.578 18.578-22.27h-8.1211c-0.17188 0-0.32812-0.078125-0.42188-0.23047-0.089844-0.14844-0.10938-0.32031-0.039062-0.46875l6.5703-15.16h-14.871l-5.7305 22.922z"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>
